import { FC } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as LeftArrowIcon } from 'images/icons/Icon-left-arrow.svg';
import { ReactComponent as RightArrowIcon } from 'images/icons/Icon-right-arrow.svg';
import EditableHotspot from 'components/EditableHotspot/EditableHotspot';

import styles from './sectionMoveControls.module.less';

interface SectionMoveControlsProps {
  onMoveUp: () => void;
  onMoveDown: () => void;
  hideUp: boolean;
  hideDown: boolean;
  showControls: boolean;
}

const SectionMoveControls: FC<SectionMoveControlsProps> = ({
  onMoveUp,
  onMoveDown,
  hideUp,
  hideDown,
  showControls,
}) => {
  if (!showControls) {
    return null;
  }

  const renderMoveOverlay = () => (
    <div className={styles.moveOverlay}>
      {/* Top Section */}
      {!hideUp ? (
        <div className={styles.top} onClick={onMoveUp}>
          <LeftArrowIcon className={styles.topIcon} />
          <label>Move</label>
        </div>
      ) : (
        <div className={styles.emptyDiv}></div>
      )}

      {/* Bottom Section */}
      {!hideDown ? (
        <div className={styles.bottom} onClick={onMoveDown}>
          <label>Move</label>
          <RightArrowIcon className={styles.bottomIcon} />
        </div>
      ) : (
        <div className={styles.emptyDiv}></div>
      )}
    </div>
  );

  return (
    <div className={styles.moveWrapper}>
      <EditableHotspot
        alwaysVisible={false}
        className={styles.hotSpotHoverContainer}
        customModal={() => <></>}
        overlayComponent={renderMoveOverlay()}
      >
        <div className={styles.moveArea}></div>
      </EditableHotspot>
    </div>
  );
};

SectionMoveControls.propTypes = {
  onMoveUp: PropTypes.func.isRequired,
  onMoveDown: PropTypes.func.isRequired,
  hideUp: PropTypes.bool.isRequired,
  hideDown: PropTypes.bool.isRequired,
  showControls: PropTypes.bool.isRequired,
};

export default SectionMoveControls;
